var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _rect, _path14, _path15, _ellipse, _path16, _path17, _g3, _path18, _path19, _path20, _path21, _path22, _g4, _path23, _path24, _path25, _g5, _path26, _path27, _path28, _path29, _path30, _g6, _path31, _path32, _path33, _path34, _path35, _path36, _g7, _path37, _path38, _path39, _path40, _path41, _g8, _path42, _path43, _path44, _g9, _path45, _path46, _path47, _path48, _g10, _path49, _rect2, _path50, _path51, _g11, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g12, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _ellipse2, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _g13, _path98, _path99, _path100, _g14, _path101, _path102, _path103, _g15, _path104, _path105, _path106, _path107, _g16, _path108, _path109, _path110, _path111, _path112, _g17, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _g18, _path126, _path127, _path128, _path129, _g19, _path130, _path131, _path132, _g20, _path133, _ellipse3, _path134, _path135, _g21, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _ellipse4, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _g22, _path160, _ellipse5, _path161, _path162, _path163, _g23, _path164, _path165, _path166, _path167, _path168, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1684,
    height: 724,
    viewBox: "0 0 1684 724",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1095.88 316.599H1128.88H1138.37L1130.6 370.425H1103.66L1095.88 316.599ZM1097.6 318.349L1104.87 368.675H1109.42L1105.51 318.349H1097.6ZM1110.86 368.675L1106.95 318.349H1127.31L1123.39 368.675H1110.86ZM1124.84 368.675H1129.39L1136.66 318.349H1128.75L1124.84 368.675Z",
    fill: "#FFCD07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.88 316.599V315.835C1095.66 315.835 1095.45 315.932 1095.31 316.099C1095.16 316.266 1095.1 316.489 1095.13 316.708L1095.88 316.599ZM1138.37 316.599L1139.13 316.708C1139.16 316.489 1139.1 316.266 1138.95 316.099C1138.81 315.932 1138.6 315.835 1138.37 315.835V316.599ZM1130.6 370.425V371.189C1130.97 371.189 1131.3 370.91 1131.35 370.535L1130.6 370.425ZM1103.66 370.425L1102.91 370.535C1102.96 370.91 1103.28 371.189 1103.66 371.189V370.425ZM1104.87 368.675L1104.11 368.784C1104.17 369.16 1104.49 369.438 1104.87 369.438V368.675ZM1097.6 318.349V317.586C1097.37 317.586 1097.16 317.682 1097.02 317.85C1096.87 318.017 1096.81 318.239 1096.84 318.459L1097.6 318.349ZM1109.42 368.675V369.438C1109.63 369.438 1109.84 369.35 1109.98 369.194C1110.13 369.037 1110.2 368.828 1110.18 368.616L1109.42 368.675ZM1105.51 318.349L1106.27 318.29C1106.24 317.893 1105.91 317.586 1105.51 317.586V318.349ZM1106.95 318.349V317.586C1106.74 317.586 1106.54 317.675 1106.39 317.831C1106.25 317.987 1106.17 318.197 1106.19 318.409L1106.95 318.349ZM1110.86 368.675L1110.1 368.734C1110.13 369.132 1110.47 369.438 1110.86 369.438V368.675ZM1127.31 318.349L1128.07 318.409C1128.08 318.197 1128.01 317.987 1127.87 317.831C1127.72 317.675 1127.52 317.586 1127.31 317.586V318.349ZM1123.39 368.675V369.438C1123.79 369.438 1124.12 369.132 1124.16 368.734L1123.39 368.675ZM1129.39 368.675V369.438C1129.77 369.438 1130.09 369.16 1130.15 368.784L1129.39 368.675ZM1124.84 368.675L1124.08 368.616C1124.06 368.828 1124.13 369.037 1124.28 369.194C1124.42 369.35 1124.62 369.438 1124.84 369.438V368.675ZM1136.66 318.349L1137.42 318.459C1137.45 318.239 1137.38 318.017 1137.24 317.85C1137.09 317.682 1136.88 317.586 1136.66 317.586V318.349ZM1128.75 318.349V317.586C1128.35 317.586 1128.02 317.893 1127.99 318.29L1128.75 318.349ZM1128.88 315.835H1095.88V317.362H1128.88V315.835ZM1138.37 315.835H1128.88V317.362H1138.37V315.835ZM1131.35 370.535L1139.13 316.708L1137.62 316.489L1129.84 370.316L1131.35 370.535ZM1103.66 371.189H1130.6V369.662H1103.66V371.189ZM1095.13 316.708L1102.91 370.535L1104.42 370.316L1096.64 316.489L1095.13 316.708ZM1105.62 368.566L1098.35 318.24L1096.84 318.459L1104.11 368.784L1105.62 368.566ZM1109.42 367.912H1104.87V369.438H1109.42V367.912ZM1104.75 318.409L1108.66 368.734L1110.18 368.616L1106.27 318.29L1104.75 318.409ZM1097.6 319.113H1105.51V317.586H1097.6V319.113ZM1106.19 318.409L1110.1 368.734L1111.62 368.616L1107.71 318.29L1106.19 318.409ZM1127.31 317.586H1106.95V319.113H1127.31V317.586ZM1124.16 368.734L1128.07 318.409L1126.55 318.29L1122.63 368.616L1124.16 368.734ZM1110.86 369.438H1123.39V367.912H1110.86V369.438ZM1129.39 367.912H1124.84V369.438H1129.39V367.912ZM1135.91 318.24L1128.63 368.566L1130.15 368.784L1137.42 318.459L1135.91 318.24ZM1128.75 319.113H1136.66V317.586H1128.75V319.113ZM1125.6 368.734L1129.51 318.409L1127.99 318.29L1124.08 368.616L1125.6 368.734Z",
    fill: "#3D3D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.01 19.0938C856.321 19.0938 1095.69 315.228 1095.69 315.228H1138.33C1138.33 315.228 1377.69 19.0938 1117.01 19.0938Z",
    fill: "#FFCD07"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 995,
    y: 19,
    width: 244,
    height: 297
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1117.13 19.2754C856.711 19.2754 1095.83 315.099 1095.83 315.099H1138.43C1138.43 315.099 1377.55 19.2754 1117.13 19.2754Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1237.2 70.8186C1248.08 78.6992 1253.48 92.7614 1250.92 106.523C1254.54 103.984 1257.66 100.698 1260.07 96.8579C1270.14 80.8989 1266.21 59.2274 1251.3 48.4532C1242.25 41.9494 1230.75 40.7093 1220.66 45.1498C1210.58 49.5902 1203.24 59.1218 1201.13 70.5408C1212.1 62.851 1226.33 62.9606 1237.2 70.8186Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.75 186.114C1016.63 193.994 1022.04 208.056 1019.47 221.818C1023.1 219.279 1026.21 215.993 1028.62 212.153C1038.69 196.194 1034.76 174.522 1019.85 163.748C1010.8 157.244 999.304 156.004 989.217 160.445C979.13 164.885 971.796 174.417 969.681 185.836C980.652 178.146 994.883 178.256 1005.75 186.114Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1117.01 19.0938C856.321 19.0938 1095.69 315.228 1095.69 315.228H1138.33C1138.33 315.228 1377.69 19.0938 1117.01 19.0938Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.27 19.0938C944.441 19.0938 1103.14 315.228 1103.14 315.228H1131.41C1131.41 315.228 1290.11 19.0938 1117.27 19.0938Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.92 42.4189L1062.3 64.9209L1085.5 68.5293L1068.71 86.0445L1072.67 110.776L1051.92 99.0996L1031.17 110.776L1035.14 86.0445L1018.35 68.5293L1041.55 64.9209L1051.92 42.4189Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.97 196.179C1173.96 182.154 1181.83 169.486 1193.94 164.026C1189.95 162.232 1185.66 161.31 1181.33 161.314C1163.34 161.314 1148.76 176.924 1148.76 196.179C1148.76 215.435 1163.34 231.044 1181.33 231.044C1185.66 231.048 1189.95 230.126 1193.94 228.333C1181.83 222.873 1173.96 210.205 1173.97 196.179Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1117.27 19.0938C944.441 19.0938 1103.14 315.228 1103.14 315.228H1131.41C1131.41 315.228 1290.11 19.0938 1117.27 19.0938Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.01 19.0938C1049.25 19.0938 1111.46 315.228 1111.46 315.228H1122.55C1122.55 315.228 1184.76 19.0938 1117.01 19.0938Z",
    fill: "#FFCD07",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.71 418.362H1109.83C1106.19 418.362 1102.7 416.822 1100.13 414.08C1097.55 411.338 1096.1 407.619 1096.1 403.742V367.097H1138.44V403.742C1138.44 407.619 1137 411.338 1134.42 414.08C1131.85 416.822 1128.35 418.362 1124.71 418.362Z",
    fill: "#4F4F5B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1095,
    y: 367,
    width: 44,
    height: 52
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.59 418.656H1109.67C1106.02 418.656 1102.52 417.109 1099.94 414.356C1097.36 411.602 1095.91 407.868 1095.91 403.974V367.174H1138.35V403.974C1138.35 407.868 1136.9 411.602 1134.32 414.356C1131.74 417.109 1128.24 418.656 1124.59 418.656Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1089.27 374.698C1139.52 372.654 1139.05 400.577 1136.66 420.719C1134.27 440.861 1146.19 353.244 1146.19 353.244L1106.95 360.294",
    fill: "#3D3D3C"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.71 418.362H1109.83C1106.19 418.362 1102.7 416.822 1100.13 414.08C1097.55 411.338 1096.1 407.619 1096.1 403.742V367.097H1138.44V403.742C1138.44 407.619 1137 411.338 1134.42 414.08C1131.85 416.822 1128.35 418.362 1124.71 418.362V418.362Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1091.82,
    y: 364.685,
    width: 50.914,
    height: 10.2531,
    rx: 1.89456,
    fill: "white",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.34 310.403H1089.67L1095.22 320.656H1138.79L1144.34 310.403Z",
    fill: "white",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.11 391.222C1113.5 393.227 1116.55 394.299 1119.69 394.235",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1000.17,
    cy: 30.8548,
    rx: 13.3984,
    ry: 15.3797,
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.03 58.2358C1100.46 52.6678 1107.81 45.9976 1107.68 44.4955C1107.54 42.9934 1107.19 32.1499 1108.61 29.8915C1110.02 27.6332 1110.1 17.3186 1109.38 15.8979C1108.66 14.4773 1113.34 15.6698 1114.94 21.146C1116.55 26.6222 1115.29 30.135 1115.29 30.135C1115.29 30.135 1125.18 23.4036 1130.2 18.924C1135.21 14.4444 1132.18 21.3702 1132.18 21.3702C1132.18 21.3702 1141.85 13.5656 1143.65 14.3199C1145.45 15.0742 1144.88 17.5817 1144.35 18.6617C1143.82 19.7417 1135.51 26.9629 1135.51 26.9629C1135.51 26.9629 1139.07 24.5518 1140.13 27.0541C1141.18 29.5564 1137.38 32.1981 1137.38 32.1981C1137.38 32.1981 1139.53 33.7865 1139.67 35.9735C1139.82 38.1605 1138.38 38.1164 1138.38 38.1164C1138.38 38.1164 1140.24 40.678 1138.87 43.1262C1137.51 45.5744 1123.93 54.8323 1119.78 57.5724L1101.04 78.1998",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1095,
    y: 14,
    width: 51,
    height: 65
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1095.08 58.3468C1100.53 52.7929 1107.91 46.1395 1107.77 44.6412C1107.63 43.1429 1107.28 32.3268 1108.7 30.0742C1110.12 27.8216 1110.2 17.533 1109.48 16.116C1108.76 14.6989 1113.45 15.8885 1115.06 21.3508C1116.67 26.8131 1115.41 30.3171 1115.41 30.3171C1115.41 30.3171 1125.34 23.6027 1130.37 19.1344C1135.41 14.6661 1132.36 21.5744 1132.36 21.5744C1132.36 21.5744 1142.07 13.7896 1143.88 14.5419C1145.68 15.2943 1145.12 17.7955 1144.58 18.8728C1144.05 19.95 1135.71 27.153 1135.71 27.153C1135.71 27.153 1139.28 24.748 1140.34 27.2439C1141.4 29.7399 1137.58 32.3749 1137.58 32.3749C1137.58 32.3749 1139.74 33.9593 1139.89 36.1408C1140.04 38.3222 1138.59 38.2783 1138.59 38.2783C1138.59 38.2783 1140.46 40.8334 1139.08 43.2754C1137.71 45.7174 1124.09 54.9519 1119.91 57.6851L1101.1 78.2604",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1095.08 68.522L1102.3 51.1968L1126.24 75.4654L1098.06 81.8398L1099.34 66.3639",
    fill: "#CFCFD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M1113.69 19.3481C1116.24 28.3196 1117.36 30.9586 1115.45 37.7883C1113.53 44.618 1118.4 53.3008 1120.91 56.216C1123.42 59.1311 1125.81 55.0333 1126.77 54.8626C1127.73 54.6918 1129.8 42.0569 1129.8 42.0569L1113.69 19.3481",
    fill: "url(#paint0_linear_683_328)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.03 58.2358C1100.46 52.6678 1107.81 45.9976 1107.68 44.4955C1107.54 42.9934 1107.19 32.1499 1108.61 29.8915C1110.02 27.6332 1110.1 17.3186 1109.38 15.8979C1108.66 14.4773 1113.34 15.6698 1114.94 21.146C1116.55 26.6222 1115.29 30.135 1115.29 30.135C1115.29 30.135 1125.18 23.4036 1130.2 18.924C1135.21 14.4444 1132.18 21.3702 1132.18 21.3702C1132.18 21.3702 1141.85 13.5656 1143.65 14.3199C1145.45 15.0742 1144.88 17.5817 1144.35 18.6617C1143.82 19.7417 1135.51 26.9629 1135.51 26.9629C1135.51 26.9629 1139.07 24.5518 1140.13 27.0541C1141.18 29.5564 1137.38 32.1981 1137.38 32.1981C1137.38 32.1981 1139.53 33.7865 1139.67 35.9735C1139.82 38.1605 1138.38 38.1164 1138.38 38.1164C1138.38 38.1164 1140.24 40.678 1138.87 43.1262C1137.51 45.5744 1123.93 54.8323 1119.78 57.5724L1101.04 78.1998",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.02 59.1352L1121.24 63.6956C1120.77 63.7838 1120.29 63.6717 1119.91 63.3839C1119.52 63.0962 1119.26 62.6563 1119.17 62.1614L1110.07 7.79399C1109.89 6.76335 1110.53 5.77711 1111.5 5.5898L1135.29 1.02944C1135.75 0.941155 1136.23 1.05326 1136.61 1.34105C1137 1.62884 1137.26 2.06868 1137.35 2.56361L1146.45 56.931C1146.63 57.9616 1145.99 58.9479 1145.02 59.1352Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.13 54.6775L1121.16 58.8755C1120.78 58.9484 1120.38 58.8558 1120.06 58.618C1119.74 58.3801 1119.52 58.0166 1119.46 57.6076L1111.67 11.2657C1111.53 10.4139 1112.06 9.59882 1112.86 9.44401L1134.82 5.24602C1135.2 5.17304 1135.6 5.26568 1135.92 5.50353C1136.24 5.74137 1136.46 6.10489 1136.53 6.51394L1144.31 52.8558C1144.46 53.7076 1143.93 54.5227 1143.13 54.6775Z",
    fill: "#ECEDEE",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.15 51.0596C1115.56 62.1174 1113.7 78.1335 1113.7 78.1335C1113.7 78.1335 1049.84 162.176 1043.24 164.369C1036.64 166.562 965.871 121.801 965.871 121.801L992.392 92.6627L1037 117.299L1102.15 51.0596Z",
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 965,
    y: 51,
    width: 149,
    height: 114
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1102.3 51.1968C1115.74 62.2504 1113.88 78.2605 1113.88 78.2605C1113.88 78.2605 1049.87 162.271 1043.26 164.463C1036.65 166.656 965.712 121.912 965.712 121.912L992.294 92.7842L1037 117.411L1102.3 51.1968Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M986.72 114.622L997.117 99.6758C997.117 99.6758 1013.18 114.574 1018.17 137.502C1025.28 170.199 1064.88 164.541 1064.88 164.541L1021.12 174.097L994.821 151.145L986.72 114.622Z",
    fill: "#CFCFD0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1044.27,
    cy: 158.048,
    rx: 15.5136,
    ry: 10.671,
    fill: "#FFCD07",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1102.15 51.0596C1115.56 62.1174 1113.7 78.1335 1113.7 78.1335C1113.7 78.1335 1049.84 162.176 1043.24 164.369C1036.64 166.562 965.871 121.801 965.871 121.801L992.392 92.6627L1037 117.299L1102.15 51.0596Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.81 478.675L1091.28 546.345L1071.24 552.256L1051.62 493.744L1070.81 478.675Z",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1051,
    y: 478,
    width: 41,
    height: 75
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070.92 478.753L1091.25 546.175L1071.36 552.065L1051.88 493.767L1070.92 478.753Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1051.88 527.675C1061.15 527.675 1080.03 500.805 1080.03 500.805L1058.45 499.893L1055.56 503.638L1051.88 527.675Z",
    fill: "#CFCFD0"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070.81 478.675L1091.28 546.345L1071.24 552.256L1051.62 493.744L1070.81 478.675V478.675Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.12 551.905C1070.9 541.185 1069.69 534.159 1069.86 529.555C1074.72 529.505 1080.63 527.736 1084.91 520.894C1084.91 520.894 1093.52 564.848 1111.91 559.455C1133.47 553.134 1131.99 571.59 1131.99 571.59C1131.99 571.59 1115.62 579.14 1106.34 579.949C1101 580.414 1086.24 577.581 1074.65 575.088C1078.26 571.209 1080 564.28 1075.12 551.905Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.29 551.492C1065.97 542.233 1061.29 527.528 1061.29 527.528C1064.11 528.652 1067.09 529.217 1070.1 529.195C1069.93 533.844 1071.14 540.939 1075.4 551.764C1080.31 564.261 1078.56 571.258 1074.92 575.175C1066.3 573.315 1059.42 571.643 1059.42 571.643C1059.42 571.643 1056.62 560.75 1061.29 551.492Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M852.253 380.366L798.123 370.762L803.929 344.781L851.66 350.874L852.253 380.366Z",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 798,
    y: 344,
    width: 55,
    height: 37
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M852.476 380.144L798.039 370.604L803.878 344.795L851.879 350.847L852.476 380.144Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M838.119 347.605C838.119 347.605 839.972 377.952 832.037 392.156C822.843 408.614 850.047 402.053 850.047 402.053L866.841 383.366L838.119 347.605Z",
    fill: "#CFCFD0"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M852.253 380.366L798.123 370.762L803.929 344.781L851.66 350.874L852.253 380.366V380.366Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M802.142 349.457C811.33 349.837 816.585 351.892 819.561 354.338C817.207 359.974 815.477 367.667 817.916 375.969C817.916 375.969 784.517 364.351 779.061 388.237C772.667 416.231 761.144 405.476 761.144 405.476C761.144 405.476 764.173 382.87 768.195 371.755C770.508 365.364 779.641 349.702 786.987 337.544C787.788 343.614 791.534 349.019 802.142 349.457Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M809.134 333.305C812.949 343.256 824.92 345.056 824.92 345.056C822.719 347.895 820.901 351.051 819.519 354.431C816.536 351.962 811.269 349.887 802.059 349.503C791.426 349.061 787.672 343.604 786.869 337.475C792.31 328.401 796.774 321.259 796.774 321.259C796.774 321.259 805.32 323.354 809.134 333.305Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M790.34 316.435L797.051 321.381C797.051 321.381 789.56 337.385 779.437 352.341C763.319 376.153 762.482 406.3 762.482 406.3L759 404.113C759 404.113 760.54 377.757 769.855 361.8C779.17 345.842 784.267 339.039 784.267 339.039L780.407 336.194C780.407 336.194 787.463 319.594 790.34 316.435Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M996.42 55.8843C996.42 55.8843 985.609 80.879 992.293 92.6749L965.871 86.8077L979.374 55.8843H996.42Z",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 965,
    y: 55,
    width: 32,
    height: 38
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.442 55.6899C996.442 55.6899 985.575 80.8906 992.293 92.7836L965.735 86.8681L979.307 55.6899H996.442Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.94 64.9683C1019.94 71.7578 1003.07 80.9905 1000.06 92.7124C997.051 104.434 983.247 71.7578 983.247 64.9683C983.247 58.1788 991.461 52.6748 1001.59 52.6748C1011.73 52.6748 1019.94 58.1788 1019.94 64.9683Z",
    fill: "#CFCFD0"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.42 55.8843C996.42 55.8843 985.609 80.879 992.293 92.6749L965.871 86.8077L979.374 55.8843H996.42Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M837.283 337.634C822.422 359.393 834.699 398.318 842.147 397.487C842.147 397.487 934.183 403.933 946.534 401.549C958.886 399.166 1011.79 205.328 1002.93 192.922C994.068 180.515 947.844 184.286 947.844 184.286C947.844 184.286 920.3 340.006 921.851 346.543L837.283 337.634Z",
    fill: "#4F4F5B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M837.283 337.634C822.422 359.393 834.699 398.318 842.147 397.487C842.147 397.487 934.183 403.933 946.534 401.549C958.886 399.166 1011.79 205.328 1002.93 192.922C994.068 180.515 947.844 184.286 947.844 184.286C947.844 184.286 920.3 340.006 921.851 346.543V346.543L837.283 337.634Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M945.881 248.719C953.469 275.426 984.568 334.695 991.839 354.181L1021.73 515.275C1038.79 527.536 1080.03 500.678 1080.03 500.678C1080.03 500.678 1042.87 363.822 1041.24 356.584C1039.61 349.347 1010.04 187.366 1010.04 187.366H943.898C943.898 187.366 944.625 190.32 945.93 195.501",
    fill: "#4F4F5B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 943,
    y: 187,
    width: 138,
    height: 332
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M945.765 248.742C953.36 275.459 984.487 334.753 991.765 354.248L1021.69 515.409C1038.76 527.675 1080.03 500.806 1080.03 500.806C1080.03 500.806 1042.84 363.892 1041.21 356.652C1039.58 349.412 1009.99 187.363 1009.99 187.363H943.78C943.78 187.363 944.508 190.318 945.814 195.501",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.91 229.703C1014.97 214.619 1022.99 266.776 1038.13 340.515C1053.26 414.254 1029.1 226.894 1029.1 226.894L1004.47 196.227",
    fill: "#2D2F3A"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M945.881 248.719C953.469 275.426 984.568 334.695 991.839 354.181L1021.73 515.275C1038.79 527.536 1080.03 500.678 1080.03 500.678C1080.03 500.678 1042.87 363.822 1041.24 356.584C1039.61 349.347 1010.04 187.366 1010.04 187.366H943.898C943.898 187.366 944.625 190.32 945.93 195.501",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M914.732 172.469C908.329 248.864 1003 222.996 1016.83 209.049C1030.65 195.102 994.859 94.1313 994.859 94.1313L961.087 86.0405C961.087 86.0405 915.46 163.787 914.732 172.469Z",
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 914,
    y: 85,
    width: 106,
    height: 140
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.756 172.267C908.358 248.741 1002.96 222.847 1016.77 208.886C1030.58 194.924 994.821 93.8487 994.821 93.8487L961.076 85.7495C961.076 85.7495 915.483 163.577 914.756 172.267Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M953.677 129.306L965.712 106.996C965.712 106.996 972.14 129.401 965.712 140.825C959.285 152.249 955.138 163.113 970.77 162.43C986.402 161.747 999.482 174.269 999.482 174.269C999.482 174.269 1013.67 220.16 1005.84 226.894C944.775 279.408 923.122 188.552 923.122 188.552L945.611 130.672L953.677 129.306Z",
    fill: "#CFCFD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.089 116.923C1000.64 119.008 1010.08 109.179 1010.08 109.179L1024.01 174.702L992.111 183.582L981.089 116.923Z",
    fill: "#FFCD07",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.732 172.469C908.329 248.864 1003 222.996 1016.83 209.049C1030.65 195.102 994.859 94.1313 994.859 94.1313L961.087 86.0405C961.087 86.0405 915.46 163.787 914.732 172.469Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.25 152.716V151.178H1020.96V152.716H1018.93V157.813H1046.26V152.716H1028.25Z",
    fill: "#ECEDEE",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.39 159.779C1018.74 160.178 1021.19 184.948 1023.05 195.608C1024.23 202.391 1043.55 200.594 1043.88 195.446L1047.33 158.416L1018.39 159.779Z",
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1018,
    y: 158,
    width: 30,
    height: 43
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.17 159.537C1018.51 159.942 1020.98 185.046 1022.86 195.85C1024.05 202.725 1043.51 200.904 1043.84 195.686L1047.32 158.155L1018.17 159.537Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.14 196.227C1030.75 193.391 1042.15 184.242 1042.15 184.242L1047.03 176.735L1014.77 171.128L1019.14 194.053",
    fill: "#CFCFD0"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.39 159.779C1018.74 160.178 1021.19 184.948 1023.05 195.608C1024.23 202.391 1043.55 200.594 1043.88 195.446L1047.33 158.416L1018.39 159.779Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1016.79,
    y: 157.209,
    width: 32.1562,
    height: 3.01562,
    fill: "#ECEDEE",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M997.125 177.775C1006.43 177.775 1011.5 171.54 1014.74 171.252C1017.99 170.964 1023.2 168.375 1026.72 168.758C1030.25 169.142 1044.34 168.489 1046.03 168.72C1047.73 168.95 1047.02 171.54 1042.37 172.307C1042.37 172.307 1052.21 171.54 1053.28 172.307C1054.35 173.075 1054.21 176.336 1046.96 176.816C1047.56 177.76 1047.56 178.998 1046.96 179.942C1045.93 181.58 1040.87 182.091 1040.87 182.091C1040.87 182.091 1043.03 183.37 1042.09 184.265C1041.15 185.161 1027.71 189.285 1023.34 189.669C1018.97 190.052 996.42 194 996.42 194",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 996,
    y: 168,
    width: 58,
    height: 27
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.133 177.702C1006.45 177.702 1011.53 171.418 1014.77 171.128C1018.02 170.838 1023.24 168.228 1026.77 168.615C1030.3 169.002 1044.41 168.344 1046.1 168.576C1047.79 168.808 1047.09 171.418 1042.43 172.192C1042.43 172.192 1052.28 171.418 1053.35 172.192C1054.43 172.965 1054.29 176.251 1047.03 176.735C1047.63 177.686 1047.63 178.934 1047.03 179.885C1045.99 181.536 1040.93 182.051 1040.93 182.051C1040.93 182.051 1043.09 183.34 1042.15 184.243C1041.21 185.145 1027.76 189.301 1023.38 189.688C1019.01 190.075 996.427 194.053 996.427 194.053",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1014.69 199.003L1005.43 175.931L993.845 191.228L997.142 202.156L1014.69 199.003Z",
    fill: "#CFCFD0"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M997.125 177.775C1006.43 177.775 1011.5 171.54 1014.74 171.252C1017.99 170.964 1023.2 168.375 1026.72 168.758C1030.25 169.142 1044.34 168.489 1046.03 168.72C1047.73 168.95 1047.02 171.54 1042.37 172.307C1042.37 172.307 1052.21 171.54 1053.28 172.307C1054.35 173.075 1054.21 176.336 1046.96 176.816C1047.56 177.76 1047.56 178.998 1046.96 179.942C1045.93 181.58 1040.87 182.091 1040.87 182.091C1040.87 182.091 1043.03 183.37 1042.09 184.265C1041.15 185.161 1027.71 189.285 1023.34 189.669C1018.97 190.052 996.42 194 996.42 194",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M967.582 73.064C963.279 81.4353 994.812 94.1028 994.812 94.1028C994.812 94.1028 955.8 97.5427 953.731 83.768C951.661 69.9933 967.582 73.064 967.582 73.064Z",
    fill: "#ECEDEE",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M979.001 60.8533C976.575 56.5968 974.845 51.3208 974.191 45.4903C972.441 29.8859 979.054 16.2191 988.962 14.9647C998.871 13.7103 1008.32 25.3432 1010.07 40.9476C1011.82 56.552 1005.21 70.2188 995.302 71.4732C992.089 71.8799 988.925 70.9318 986.055 68.9327",
    fill: "#F5F6F7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M979.001 60.8533C976.575 56.5968 974.845 51.3208 974.191 45.4903C972.441 29.8859 979.054 16.2191 988.962 14.9647C998.871 13.7103 1008.32 25.3432 1010.07 40.9476C1011.82 56.552 1005.21 70.2188 995.302 71.4732C992.089 71.8799 988.925 70.9318 986.055 68.9327",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M904.453 213.903C904.453 213.903 915.564 186.874 914.932 179.201L913.112 178.319C913.112 178.319 908.413 199.405 901.559 212.5L904.453 213.903Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M925.676 225.771C925.676 225.771 937.989 198.46 943.852 194L945.506 195.848C945.506 195.848 933.482 213.235 928.512 227.172L925.676 225.771Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M881.425 185.039L877.442 166.859C877.442 166.859 929.338 186.862 976.59 215.41L948.82 220.537L881.425 185.039Z",
    fill: "#FFCD07",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M877.722 166.859L862.818 230.96C861.329 237.345 864.295 243.959 869.895 246.736L925.386 274.154C931.032 276.942 937.741 275.008 941.296 269.569L976.59 215.711C976.59 215.711 903.988 197.005 877.722 166.859Z",
    fill: "#FFCD07"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M877.722 166.859L862.818 230.96C861.329 237.345 864.295 243.959 869.895 246.736L925.386 274.154C931.032 276.942 937.741 275.008 941.296 269.569L976.59 215.711C976.59 215.711 903.988 197.005 877.722 166.859Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M931.286 213.3L913.35 204.361L914.171 202.444L932.107 211.383L931.286 213.3Z",
    fill: "#F5F6F7",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M935.422 228.981C935.422 228.981 946.088 202.41 945.481 194.867L943.734 194C943.734 194 939.223 214.729 932.643 227.602L935.422 228.981Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M931.591 229.714C931.591 229.714 924.126 246.011 922.461 248.674L925.291 250.091C925.291 250.091 934.198 233.123 934.251 231.046C934.303 228.97 931.591 229.714 931.591 229.714Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M934.812 232.449L931.394 230.769C930.621 230.387 930.285 229.414 930.642 228.593L931.109 227.52C931.279 227.126 931.591 226.82 931.975 226.67C932.358 226.52 932.783 226.538 933.154 226.72L936.572 228.4C937.345 228.782 937.681 229.755 937.324 230.575L936.857 231.649C936.687 232.043 936.375 232.349 935.991 232.499C935.608 232.649 935.183 232.631 934.812 232.449Z",
    fill: "#F5F6F7",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M895.128 210.09C895.128 210.09 907.441 182.778 913.304 178.319L914.958 180.166C914.958 180.166 902.933 197.554 897.964 211.491L895.128 210.09Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M916.233 248.219C917.922 246.069 920.659 245.216 923.167 246.058C924.814 246.604 926.189 247.828 926.987 249.459C927.785 251.091 927.94 252.994 927.417 254.748C926.63 257.424 924.408 259.331 921.789 259.578C919.17 259.826 916.668 258.366 915.452 255.879C914.236 253.392 914.544 250.369 916.233 248.219ZM917.55 253.037C917.688 254.623 918.708 255.964 920.135 256.434H920.135C922.075 257.07 924.132 255.917 924.742 253.852C925.189 252.332 924.732 250.675 923.586 249.654C922.44 248.634 920.829 248.451 919.507 249.192C918.185 249.933 917.413 251.451 917.55 253.037Z",
    fill: "#F5F6F7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M923.167 246.058L922.924 246.782L922.927 246.783L923.167 246.058ZM927.417 254.748L926.686 254.53L926.685 254.532L927.417 254.748ZM921.789 259.578L921.717 258.819H921.717L921.789 259.578ZM915.452 255.879L914.766 256.214H914.766L915.452 255.879ZM920.135 256.434V257.197C920.51 257.197 920.83 256.925 920.889 256.554C920.948 256.184 920.73 255.826 920.374 255.709L920.135 256.434ZM917.55 253.037L918.311 252.971L917.55 253.037ZM920.135 256.434V255.67C919.76 255.67 919.441 255.943 919.382 256.313C919.322 256.683 919.541 257.042 919.897 257.159L920.135 256.434ZM924.742 253.852L925.474 254.068L925.474 254.068L924.742 253.852ZM923.586 249.654L924.094 249.084L923.586 249.654ZM919.507 249.192L919.134 248.526L919.507 249.192ZM923.41 245.334C920.582 244.385 917.512 245.355 915.633 247.747L916.833 248.69C918.331 246.783 920.735 246.047 922.924 246.782L923.41 245.334ZM927.673 249.124C926.789 247.318 925.259 245.947 923.407 245.333L922.927 246.783C924.369 247.261 925.589 248.338 926.302 249.795L927.673 249.124ZM928.149 254.966C928.726 253.03 928.556 250.929 927.673 249.124L926.302 249.795C927.015 251.253 927.154 252.958 926.686 254.53L928.149 254.966ZM921.861 260.338C924.815 260.059 927.281 257.915 928.149 254.963L926.685 254.532C925.979 256.933 924.002 258.603 921.717 258.819L921.861 260.338ZM914.766 256.214C916.113 258.967 918.904 260.618 921.861 260.338L921.717 258.819C919.435 259.034 917.224 257.765 916.138 255.544L914.766 256.214ZM915.633 247.747C913.76 250.131 913.424 253.469 914.766 256.214L916.138 255.544C915.048 253.316 915.328 250.606 916.833 248.69L915.633 247.747ZM920.374 255.709C919.259 255.342 918.424 254.276 918.311 252.971L916.79 253.103C916.952 254.97 918.158 256.586 919.897 257.159L920.374 255.709ZM920.135 257.197H920.135V255.67H920.135V257.197ZM924.009 253.636C923.51 255.327 921.866 256.198 920.373 255.708L919.897 257.159C922.283 257.941 924.754 256.507 925.474 254.068L924.009 253.636ZM923.078 250.224C923.995 251.041 924.376 252.389 924.009 253.637L925.474 254.068C926.001 252.276 925.469 250.309 924.094 249.084L923.078 250.224ZM919.881 249.858C920.914 249.279 922.171 249.416 923.078 250.224L924.094 249.084C922.708 247.851 920.745 247.623 919.134 248.526L919.881 249.858ZM918.311 252.971C918.197 251.664 918.837 250.442 919.881 249.858L919.134 248.526C917.534 249.423 916.628 251.237 916.79 253.103L918.311 252.971Z",
    fill: "#3D3D3C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M962.64 98.6559C962.64 98.6559 972.416 106.581 943.362 195.686L945.558 196.412C945.558 196.412 976.749 112.061 963.792 94.4844L962.64 98.6559Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.34 176.072C1009.04 183.984 1003.43 204.856 1003.43 204.856C1003.43 204.856 894.416 196.671 892.657 183.726C888.246 151.273 955.165 79.3655 961.016 85.8483C966.867 92.3312 963.506 136.728 956.881 145.382C950.256 154.035 939.896 162.509 939.896 162.509L1005.34 176.072Z",
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 892,
    y: 85,
    width: 115,
    height: 120
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1005.43 175.931C1009.14 183.84 1003.53 204.702 1003.53 204.702C1003.53 204.702 894.424 196.52 892.663 183.582C888.249 151.144 955.22 79.2702 961.075 85.75C966.931 92.2299 963.568 136.606 956.937 145.255C950.307 153.905 939.939 162.375 939.939 162.375L1005.43 175.931Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_683_328)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 895.377,
    cy: 184.429,
    rx: 12.981,
    ry: 15.9041,
    fill: "#FFCD07",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1005.34 176.072C1009.04 183.984 1003.43 204.856 1003.43 204.856C1003.43 204.856 894.416 196.671 892.657 183.726C888.246 151.273 955.165 79.3655 961.016 85.8483C966.867 92.3312 963.506 136.728 956.881 145.382C950.256 154.035 939.896 162.509 939.896 162.509L1005.34 176.072Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M979.709 48.514C1009.11 41.0421 1017.78 26.2639 1000.31 14.6946C988.806 7.0769 955.046 -8.68162 949.223 51.7508C945.021 95.3693 851.735 11.7966 851.735 11.7966L781.509 121.945C781.509 121.945 885.151 184.971 937.731 143.93C990.31 102.89 979.709 48.514 979.709 48.514Z",
    fill: "#4F4F5B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M979.709 48.514C1009.11 41.0421 1017.78 26.2639 1000.31 14.6946C988.806 7.0769 955.046 -8.68162 949.223 51.7508C945.021 95.3693 851.735 11.7966 851.735 11.7966L781.509 121.945C781.509 121.945 885.151 184.971 937.731 143.93C990.31 102.89 979.709 48.514 979.709 48.514Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M981.911 62.4783C979.748 62.691 977.587 62.0594 975.839 60.7042C972.03 57.8652 970.646 52.7334 972.749 49.242C974.852 45.7507 979.644 45.2218 983.454 48.0609C984.312 48.6994 985.07 49.4749 985.701 50.3591",
    fill: "#F5F6F7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M981.911 62.4783C979.748 62.691 977.587 62.0594 975.839 60.7042C972.03 57.8652 970.646 52.7334 972.749 49.242C974.852 45.7507 979.644 45.2218 983.454 48.0609C984.312 48.6994 985.07 49.4749 985.701 50.3591",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M896.965 213.752L893.81 212.072C893.097 211.69 892.786 210.718 893.116 209.897L893.547 208.823C893.704 208.429 893.992 208.123 894.346 207.973C894.7 207.823 895.092 207.841 895.434 208.023L898.589 209.703C899.303 210.085 899.613 211.058 899.284 211.879L898.853 212.952C898.695 213.346 898.408 213.652 898.054 213.802C897.699 213.953 897.308 213.935 896.965 213.752Z",
    fill: "#F5F6F7",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M890.307 232.882C888.815 228.549 889.921 223.693 893.118 220.551C891.682 220.478 890.248 220.71 888.899 221.233C884.76 222.807 881.932 226.865 881.74 231.504C881.548 236.144 884.029 240.447 888.021 242.397C892.013 244.348 896.726 243.559 899.951 240.401C895.595 240.176 891.792 237.212 890.307 232.882Z",
    fill: "#FFCD07",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.85 45.9856C1001.4 46.247 1000.88 46.3053 1000.39 46.1475C999.904 45.9898 999.496 45.629 999.256 45.1449L997.722 42.0593C997.22 41.0509 997.566 39.7932 998.496 39.2461C998.942 38.9846 999.467 38.9263 999.953 39.0841C1000.44 39.2419 1000.85 39.6027 1001.09 40.0868L1002.62 43.1723C1003.12 44.1808 1002.78 45.4384 1001.85 45.9856Z",
    fill: "#3D3D3C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M997.163 32.2052C991.551 35.1657 991.558 38.3605 995.176 36.7593C998.795 35.1581 1000.83 30.271 997.163 32.2052Z",
    fill: "#3D3D3C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.14 39.6001C1013.87 42.9613 1013.96 49.3815 1009.08 49.8532L1007.14 39.6001Z",
    fill: "#F5F6F7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.14 39.6001C1013.87 42.9613 1013.96 49.3815 1009.08 49.8532",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.27,
    cx: 4.40224,
    cy: 3.42563,
    rx: 4.40224,
    ry: 3.42563,
    transform: "matrix(0.939459 -0.34266 0.305256 0.95227 989.64 47.7983)",
    fill: "#CFCFD0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M999.635 53.4717C1001.78 55.0749 1004.45 55.0804 1006.6 53.4858L999.635 53.4717Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M999.635 53.4717C1001.78 55.0749 1004.45 55.0804 1006.6 53.4858",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M980.342 51.5849C979.745 51.0124 978.897 50.8969 978.193 51.2924C977.49 51.688 977.071 52.5164 977.132 53.3904C977.193 54.2644 977.722 55.0111 978.471 55.2814",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M931.036 101.119C918.983 110.016 904.525 114.66 889.769 114.375",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M836.175 51.6626C839.493 57.4892 844.641 61.7802 850.645 63.7251",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M940.146 162.034L933.179 163.844",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.22 116.8C1039.05 118.375 1040.13 119.802 1041.44 121.022",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M994.276 356.241L1001.24 354.431",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.09 450.931C1045.01 456.474 1037.64 460.414 1029.65 462.391",
    stroke: "#3D3D3C",
    strokeWidth: 1.52653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.1 636.566C1074.95 636.566 1055.4 632.979 1037.47 625.805C1019.65 618.507 1004.13 608.363 990.894 595.375C977.782 582.263 967.577 566.924 960.279 549.359C953.104 531.794 949.517 512.621 949.517 491.84C949.517 471.059 953.104 451.885 960.279 434.32C967.577 416.632 977.782 401.293 990.894 388.305C1004.13 375.193 1019.65 365.049 1037.47 357.875C1055.4 350.701 1074.95 347.113 1096.1 347.113C1117.25 347.113 1136.73 350.762 1154.55 358.061C1172.36 365.235 1187.76 375.316 1200.75 388.305C1213.86 401.293 1224.06 416.57 1231.36 434.135C1238.66 451.7 1242.31 470.935 1242.31 491.84C1242.31 512.621 1238.66 531.856 1231.36 549.545C1224.19 567.11 1214.05 582.387 1200.93 595.375C1187.82 608.363 1172.36 618.507 1154.55 625.805C1136.73 632.979 1117.25 636.566 1096.1 636.566ZM1096.1 586.654C1108.59 586.654 1120.16 584.242 1130.8 579.418C1141.56 574.594 1150.9 567.914 1158.81 559.379C1166.73 550.72 1172.85 540.701 1177.18 529.32C1181.64 517.816 1183.86 505.323 1183.86 491.84C1183.86 478.357 1181.64 465.863 1177.18 454.359C1172.85 442.855 1166.73 432.836 1158.81 424.301C1150.9 415.642 1141.56 408.962 1130.8 404.262C1120.16 399.438 1108.59 397.025 1096.1 397.025C1083.48 397.025 1071.79 399.438 1061.03 404.262C1050.39 408.962 1041.05 415.642 1033.01 424.301C1025.1 432.836 1018.91 442.855 1014.46 454.359C1010.13 465.863 1007.96 478.357 1007.96 491.84C1007.96 505.323 1010.13 517.816 1014.46 529.32C1018.91 540.824 1025.1 550.906 1033.01 559.564C1041.05 568.1 1050.39 574.779 1061.03 579.604C1071.79 584.304 1083.48 586.654 1096.1 586.654Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M272.33 631V352.68H363.434C397.08 352.68 426.211 358.37 450.827 369.75C475.442 381.13 494.492 397.211 507.975 417.992C521.458 438.773 528.2 463.389 528.2 491.84C528.2 520.167 521.458 544.783 507.975 565.688C494.492 586.469 475.442 602.549 450.827 613.93C426.211 625.31 397.08 631 363.434 631H272.33ZM329.479 581.088H365.475C387.741 581.088 406.605 577.624 422.067 570.697C437.653 563.646 449.466 553.503 457.506 540.268C465.67 526.908 469.752 510.766 469.752 491.84C469.752 472.79 465.67 456.648 457.506 443.412C449.466 430.176 437.653 420.095 422.067 413.168C406.605 406.117 387.741 402.592 365.475 402.592H329.479V581.088Z",
    fill: "#7BFF3D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M723.499 610.219C700.491 626.547 675.319 634.711 647.981 634.711C627.695 634.711 609.449 630.382 593.245 621.723C577.164 612.94 564.423 601.065 555.022 586.098C545.745 571.13 541.106 554.245 541.106 535.443C541.106 517.507 545.312 501.488 553.723 487.387C562.259 473.285 573.824 462.152 588.421 453.988C603.017 445.824 619.593 441.742 638.147 441.742C657.32 441.742 674.205 446.257 688.802 455.287C703.398 464.193 714.778 476.687 722.942 492.768C731.106 508.725 735.188 527.217 735.188 548.246V554.184H598.44C600.667 561.482 604.254 567.914 609.202 573.48C614.274 578.923 620.582 583.253 628.128 586.469C635.797 589.685 644.518 591.293 654.29 591.293C673.216 591.293 690.843 585.17 707.171 572.924L723.499 610.219ZM596.028 527.094H686.018C685.029 519.053 682.493 512.003 678.411 505.941C674.453 499.757 669.195 494.932 662.639 491.469C656.207 488.005 648.971 486.273 640.93 486.273C632.766 486.273 625.468 488.067 619.036 491.654C612.727 495.242 607.594 500.066 603.636 506.127C599.677 512.188 597.141 519.177 596.028 527.094Z",
    fill: "#4770FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M940.136 445.453L864.433 631H812.851L737.148 445.453H794.111L838.827 577.191L883.544 445.453H940.136ZM1319.97 723.773H1266.54V445.453H1313.29L1316.08 470.688C1323.99 461.658 1333.46 454.607 1344.46 449.535C1355.6 444.34 1367.72 441.742 1380.83 441.742C1397.9 441.742 1413.06 445.948 1426.29 454.359C1439.53 462.647 1449.98 474.089 1457.65 488.686C1465.32 503.158 1469.15 519.672 1469.15 538.227C1469.15 556.658 1465.32 573.171 1457.65 587.768C1449.98 602.364 1439.53 613.868 1426.29 622.279C1413.06 630.567 1397.9 634.711 1380.83 634.711C1368.71 634.711 1357.45 632.546 1347.06 628.217C1336.8 623.764 1327.77 617.641 1319.97 609.848V723.773ZM1367.29 586.84C1376.56 586.84 1384.73 584.799 1391.78 580.717C1398.83 576.511 1404.33 570.759 1408.29 563.461C1412.38 556.039 1414.42 547.628 1414.42 538.227C1414.42 528.702 1412.38 520.29 1408.29 512.992C1404.33 505.694 1398.83 499.942 1391.78 495.736C1384.73 491.531 1376.63 489.428 1367.47 489.428C1358.81 489.428 1351.02 491.345 1344.09 495.18C1337.17 498.891 1331.54 504.086 1327.21 510.766C1323 517.445 1320.59 525.115 1319.97 533.773V543.051C1320.59 551.462 1323 559.008 1327.21 565.688C1331.41 572.243 1336.98 577.439 1343.91 581.273C1350.84 584.984 1358.63 586.84 1367.29 586.84Z",
    fill: "#F9A876"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1478.53 615.043L1490.22 569.77C1493.93 573.852 1498.88 577.624 1505.07 581.088C1511.38 584.551 1518.12 587.335 1525.29 589.438C1532.59 591.417 1539.45 592.406 1545.89 592.406C1553.56 592.406 1559.56 590.984 1563.89 588.139C1568.21 585.17 1570.38 581.212 1570.38 576.264C1570.38 572.182 1568.89 568.78 1565.93 566.059C1563.08 563.214 1559.18 560.74 1554.24 558.637C1549.41 556.41 1544.03 554.245 1538.09 552.143C1530.05 549.05 1521.77 545.463 1513.23 541.381C1504.82 537.299 1497.71 531.732 1491.89 524.682C1486.08 517.631 1483.17 508.292 1483.17 496.664C1483.17 485.531 1486.08 475.883 1491.89 467.719C1497.71 459.431 1505.93 453.061 1516.57 448.607C1527.21 444.031 1539.58 441.742 1553.68 441.742C1576.56 441.742 1599.39 447.494 1622.15 458.998L1607.12 501.117C1603.16 498.025 1598.21 495.18 1592.27 492.582C1586.34 489.861 1580.21 487.696 1573.9 486.088C1567.72 484.48 1562.15 483.676 1557.21 483.676C1551.14 483.676 1546.38 484.913 1542.92 487.387C1539.58 489.861 1537.91 493.262 1537.91 497.592C1537.91 500.808 1539.08 503.715 1541.43 506.312C1543.78 508.786 1547.25 511.199 1551.82 513.549C1556.53 515.775 1562.28 518.188 1569.08 520.785C1577.49 523.878 1585.97 527.589 1594.5 531.918C1603.16 536.124 1610.4 541.814 1616.21 548.988C1622.15 556.039 1625.12 565.44 1625.12 577.191C1625.12 588.695 1621.96 598.777 1615.65 607.436C1609.47 616.094 1600.69 622.836 1589.31 627.66C1578.05 632.361 1564.81 634.711 1549.6 634.711C1524.24 634.711 1500.55 628.155 1478.53 615.043Z",
    fill: "#8057F5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M239.421 350.801C247.233 357.738 259.342 374.524 264.221 375.285C269.101 376.045 292.586 357.162 294.001 353.537C295.415 349.913 298.365 329.449 303.916 337.543C310.005 346.423 303.993 354.622 299.179 359.028C299.179 359.028 272.063 390.596 264.221 392.268C256.38 393.941 232.784 369.162 232.784 369.162L239.421 350.801Z",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 232,
    y: 335,
    width: 75,
    height: 58
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.421 350.801C247.233 357.738 259.342 374.524 264.221 375.285C269.101 376.045 292.586 357.162 294.001 353.537C295.415 349.913 298.365 329.449 303.916 337.543C310.005 346.423 303.993 354.622 299.179 359.028C299.179 359.028 272.063 390.596 264.221 392.268C256.38 393.941 232.784 369.162 232.784 369.162L239.421 350.801Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.668 385.869C243.272 376.35 253.053 369.105 252.794 365.218C252.536 361.33 236.999 367.834 236.999 367.834L237.378 381.442",
    fill: "#CFCFD0"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.421 350.801C247.233 357.738 259.342 374.524 264.221 375.285C269.101 376.045 292.586 357.162 294.001 353.537C295.415 349.913 298.365 329.449 303.916 337.543C310.005 346.423 303.993 354.622 299.179 359.028C299.179 359.028 272.063 390.596 264.221 392.268C256.38 393.941 232.784 369.162 232.784 369.162L239.421 350.801Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M239.751 379.495C239.751 379.495 250.238 370.844 253.791 363.381C253.791 363.381 240.428 341.162 237.89 342.179C235.353 343.197 223.15 366.213 239.751 379.495Z",
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 231,
    y: 342,
    width: 23,
    height: 38
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.751 379.495C239.751 379.495 250.238 370.844 253.791 363.381C253.791 363.381 240.428 341.162 237.89 342.179C235.353 343.197 223.15 366.213 239.751 379.495Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.57 353.992C253.791 363.381 230.679 379.495 230.679 379.495L236.786 387.526L262.727 371.951",
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.57 353.992C253.791 363.381 230.679 379.495 230.679 379.495L236.786 387.526L262.727 371.951",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.751 379.495C239.751 379.495 250.238 370.844 253.791 363.381C253.791 363.381 240.428 341.162 237.89 342.179C235.353 343.197 223.15 366.213 239.751 379.495Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M263.126 596.054L274.381 621.483L289.125 620.287L276.317 590.762L263.126 596.054Z",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 590,
    width: 27,
    height: 32
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.126 596.054L274.381 621.483L289.125 620.287L276.317 590.762L263.126 596.054Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.311 616.451C268.791 606.798 281.631 608.037 283.506 602.178C285.381 596.319 266.883 602.852 266.883 602.852C266.883 602.852 264.943 603.512 264.642 604.433C264.34 605.355 269.53 612.097 269.53 612.097",
    fill: "#CFCFD0"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.126 596.054L274.381 621.483L289.125 620.287L276.317 590.762L263.126 596.054V596.054Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M273.031 631.629L269.53 612.097C269.53 612.097 282.918 621.824 288.543 614.484C288.543 614.484 302.402 620.819 312.115 623.05C316.48 624.053 319.489 627.856 319.204 632.128L319.197 632.231L273.031 631.629Z",
    fill: "#ECEDEE",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M126.245 574.981L105.667 595.4L113.607 606.394L137.619 582.89L126.245 574.981Z",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 574,
    width: 33,
    height: 33
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.245 574.981L105.667 595.4L113.607 606.394L137.619 582.89L126.245 574.981Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.467 585.672C118.703 582.465 126.024 591.232 128.907 591.419C131.79 591.605 122.413 579.68 122.413 579.68L116.282 579.319L89.8496 537.018",
    fill: "#CFCFD0"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.245 574.981L105.667 595.4L113.607 606.394L137.619 582.89L126.245 574.981V574.981Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2653 599.23L112.945 587.318C112.945 587.318 109.22 602.237 119.21 603.289C119.21 603.289 119.136 616.136 121.1 624.779C122.106 629.207 119.658 633.677 115.257 635.385L97.3965 603.613C96.5683 602.137 96.9368 600.279 98.2653 599.23Z",
    fill: "#ECEDEE",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M280.674 280.451C280.016 279.525 277.449 279.417 273.475 279.995C264.229 281.34 247.324 286.418 228.825 293.686C213.792 299.593 200.956 305.67 193.072 310.382C190.88 311.819 188.726 313.316 186.611 314.873C186.606 314.878 186.6 314.883 186.594 314.888C185.031 316.288 184.4 317.388 184.894 318.084C187.08 321.166 210.293 315.241 236.742 304.849C263.191 294.457 282.86 283.534 280.674 280.451Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M242.215 302.747C242.215 302.747 231.771 323.868 238.77 337.963L220.217 352.141L215.825 328.733C215.825 328.733 225.072 305.824 223.657 296.739C222.242 287.654 242.215 302.747 242.215 302.747Z",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 215,
    y: 293,
    width: 28,
    height: 60
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.215 302.747C242.215 302.747 231.771 323.868 238.77 337.963L220.217 352.141L215.825 328.733C215.825 328.733 225.072 305.824 223.657 296.739C222.242 287.654 242.215 302.747 242.215 302.747Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.817 310.382C261.817 317.776 250.593 331.967 241.29 331.967C231.987 331.967 232.784 319.686 232.784 312.293C232.784 304.9 235.669 296.996 244.972 296.996C254.275 296.996 261.817 302.989 261.817 310.382Z",
    fill: "#CFCFD0"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.215 302.747C242.215 302.747 231.771 323.868 238.77 337.963L220.217 352.141L215.825 328.733C215.825 328.733 225.072 305.824 223.657 296.739C222.242 287.654 242.215 302.747 242.215 302.747Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M227.641 310.867C223.966 307.153 221.361 302.222 219.649 297.747C216.333 289.076 223.232 287.082 230.466 284.665C251.336 277.691 255.527 316.609 240.94 316.717C237.938 316.751 234.98 315.991 232.366 314.515",
    fill: "#F5F6F7"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M227.641 310.867C223.966 307.153 221.361 302.222 219.649 297.747C216.333 289.076 223.232 287.082 230.466 284.665C251.336 277.691 255.527 316.609 240.94 316.717C237.938 316.751 234.98 315.991 232.366 314.515",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M228.733 297.796C240.316 298.364 250.328 287.655 245.668 285.741C241.964 284.22 226.172 274.872 218.607 288.451C211.041 302.029 219.581 306.475 212.492 310.112C204.676 314.121 222.934 328.589 230.504 305.406C232.884 298.119 228.733 297.796 228.733 297.796Z",
    fill: "#ECEDEE",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M265.884 606.889C269.53 612.097 284.407 603.309 284.407 603.309C284.407 603.309 267.303 512.459 263.126 496.537C261.506 490.362 231.496 416.38 231.496 416.38L186.557 431.301C186.557 431.301 219.194 502.061 231.496 514.923C231.496 514.924 262.239 601.68 265.884 606.889Z",
    fill: "#FFCD07"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.884 606.889C269.53 612.097 284.407 603.309 284.407 603.309C284.407 603.309 267.303 512.459 263.126 496.537C261.506 490.362 231.496 416.38 231.496 416.38L186.557 431.301C186.557 431.301 219.194 502.061 231.496 514.923C231.496 514.924 262.239 601.68 265.884 606.889Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M231.496 416.38C231.496 416.38 204.564 408.937 194.071 402.165C194.071 402.165 175.199 416.38 185.656 500.77C185.656 500.77 143.558 535.51 118.903 577.721C118.903 577.721 122.529 590.664 131.223 592.109C131.223 592.109 211.062 521.143 217.856 508.867C222.169 501.073 225.841 468.979 228.368 444.624",
    fill: "#FFCD07"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M231.496 416.38C231.496 416.38 204.564 408.937 194.071 402.165C194.071 402.165 175.199 416.38 185.656 500.77C185.656 500.77 143.558 535.51 118.903 577.721C118.903 577.721 122.529 590.664 131.223 592.109C131.223 592.109 211.062 521.143 217.856 508.867C222.169 501.073 225.841 468.979 228.368 444.624",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M179.257 406.311C179.257 406.311 219.228 426.385 242.457 414.944C242.457 414.944 229.02 384.931 242.149 373.655C255.571 362.128 241.728 340.747 238.77 337.963C238.77 337.963 231.496 340.437 223.069 328.869C215.445 318.402 178.683 392.522 179.257 406.311Z",
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 179,
    y: 327,
    width: 69,
    height: 92
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.257 406.311C179.257 406.311 219.228 426.385 242.457 414.944C242.457 414.944 229.02 384.931 242.149 373.655C255.571 362.128 241.728 340.747 238.77 337.963C238.77 337.963 231.496 340.437 223.069 328.869C215.445 318.402 178.683 392.522 179.257 406.311Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_683_328)"
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M220.915 360.82C220.915 360.82 214.72 377 233.78 375.938C233.78 375.938 207.646 372.859 209.32 416.305H186.557C186.557 416.305 193.754 410.925 194.071 402.165C194.389 393.405 207.646 372.859 207.646 372.859L220.915 360.82Z",
    fill: "#CFCFD0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M229.646 347.854V370.615L266.138 357.626L229.646 347.854Z",
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 347,
    width: 38,
    height: 24
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.646 347.854V370.615L266.138 357.626L229.646 347.854Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_683_328)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.838,
    y: 339.794,
    width: 9.9858,
    height: 37.6193,
    fill: "#ECEDEE",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.646 347.854V370.615L266.138 357.626L229.646 347.854V347.854Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.257 406.311C179.257 406.311 219.228 426.385 242.457 414.944C242.457 414.944 229.02 384.931 242.149 373.655C255.571 362.128 241.728 340.747 238.77 337.963C238.77 337.963 231.496 340.437 223.069 328.869C215.445 318.402 178.683 392.522 179.257 406.311Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M201.709 448.259C201.302 453.065 186.958 475.279 184.897 466.467C182.836 457.655 193.911 447.511 193.911 447.511C193.911 447.511 184.792 382.182 189.558 374.113C194.325 366.044 204.959 321.802 223.069 328.869C241.179 335.936 207.863 383.61 207.863 383.61L201.709 448.259Z",
    fill: "#F5F6F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 328,
    width: 45,
    height: 141
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.709 448.259C201.302 453.064 186.958 475.278 184.897 466.466C182.836 457.654 193.911 447.51 193.911 447.51C193.911 447.51 184.792 382.181 189.558 374.113C194.325 366.044 204.959 321.801 223.069 328.868C241.179 335.935 207.863 383.61 207.863 383.61L201.709 448.259Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.044 376.578C199.95 359.34 214.471 367.896 220.033 364.869C225.595 361.841 188.313 353.625 188.313 353.625L184.642 357.815",
    fill: "#CFCFD0"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.709 448.259C201.302 453.065 186.958 475.279 184.897 466.467C182.836 457.655 193.911 447.511 193.911 447.511C193.911 447.511 184.792 382.182 189.558 374.113C194.325 366.044 204.959 321.802 223.069 328.869C241.179 335.936 207.863 383.61 207.863 383.61L201.709 448.259Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M192.249 356.028C192.249 356.028 217.238 367.851 224.496 364.176C224.496 364.176 242.542 328.298 223.997 325.248C205.452 322.199 192.249 356.028 192.249 356.028Z",
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 325,
    width: 41,
    height: 40
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.249 356.028C192.249 356.028 217.238 367.851 224.496 364.176C224.496 364.176 242.542 328.298 223.997 325.248C205.452 322.199 192.249 356.028 192.249 356.028Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.969 344.969C194.057 351.922 220.71 362.532 226.049 360.82C231.389 359.109 224.839 367.033 224.839 367.033L190.514 368.126",
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.969 344.969C194.057 351.922 220.71 362.532 226.049 360.82C231.389 359.109 224.839 367.033 224.839 367.033L190.514 368.126",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.249 356.028C192.249 356.028 217.238 367.851 224.496 364.176C224.496 364.176 242.542 328.298 223.997 325.248C205.452 322.199 192.249 356.028 192.249 356.028Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.406,
    cy: 284.045,
    rx: 5.34599,
    ry: 4.40584,
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M214.228 299.617C213.421 297.364 213.246 294.934 213.723 292.59C215.341 284.059 224.158 277.08 233.417 277.001C240.118 276.943 246.201 281.014 247.892 286.226",
    fill: "#4F4F5B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 213,
    y: 277,
    width: 35,
    height: 23
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.228 299.617C213.421 297.364 213.246 294.934 213.723 292.59C215.341 284.059 224.158 277.08 233.417 277.001C240.118 276.943 246.201 281.014 247.892 286.226",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.052 301.454C228.028 280.505 253.791 287.427 253.791 287.427L209.862 305.043",
    fill: "#FFCD07"
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M214.228 299.617C213.421 297.364 213.246 294.934 213.723 292.59C215.341 284.059 224.158 277.08 233.417 277.001C240.118 276.943 246.201 281.014 247.892 286.226",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M273.475 279.996C273.463 279.996 273.453 279.997 273.442 279.997C266.919 280.475 226.09 288.733 193.072 310.382C200.956 305.67 213.792 299.594 228.825 293.687C247.324 286.418 264.229 281.34 273.475 279.996Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M293.186 355.246C292.101 354.881 291.516 353.707 291.879 352.621L303.013 319.196C303.185 318.674 303.559 318.243 304.05 317.997C304.541 317.751 305.11 317.711 305.631 317.885C306.716 318.25 307.301 319.425 306.938 320.51L295.805 353.935C295.632 354.457 295.258 354.888 294.767 355.134C294.276 355.38 293.707 355.42 293.186 355.246Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M123.888 568.552L118.903 577.721C118.903 577.721 121.526 591.211 131.223 592.11L137.085 586.87C137.085 586.87 124.161 581.531 123.888 568.552Z",
    fill: "#FFCD07",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M260.641 597.811L265.691 606.944C265.691 606.944 279.092 610.803 285.043 603.074L283.772 595.303C283.772 595.303 271.716 604.533 260.641 597.811Z",
    fill: "#FFCD07",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M244.01 297.294C244.694 297.186 245.335 297.652 245.443 298.336L245.776 300.438C245.828 300.766 245.747 301.101 245.552 301.37C245.356 301.639 245.062 301.819 244.734 301.871C244.05 301.979 243.409 301.512 243.301 300.829L242.968 298.727C242.86 298.044 243.327 297.402 244.01 297.294L244.01 297.294Z",
    fill: "#3D3D3C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M244.46 292.969C240.696 293.394 240.109 295.079 242.479 294.967C244.849 294.856 246.92 292.691 244.46 292.969Z",
    fill: "#3D3D3C"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M247.728 299.175C252.743 301.381 251.815 306.457 248.476 305.814L247.728 299.175Z",
    fill: "#F5F6F7"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M247.728 299.175C252.743 301.381 251.815 306.457 248.476 305.814",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.27,
    cx: 240.345,
    cy: 303.279,
    rx: 2.10941,
    ry: 2.85273,
    transform: "rotate(-89.2641 240.345 303.279)",
    fill: "#CFCFD0"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M242.02 306.097C243.088 307.38 244.772 307.978 246.411 307.656L242.02 306.097Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M242.02 306.097C243.088 307.38 244.772 307.978 246.411 307.656",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M232.297 301.499C224.44 296.945 222.079 307.192 231.843 309.105L232.297 301.499Z",
    fill: "#F5F6F7"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M232.297 301.499C224.44 296.945 222.079 307.192 231.843 309.105",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M231.074 303.463C230.826 303.041 230.348 302.81 229.864 302.879C229.379 302.948 228.985 303.303 228.865 303.777C228.745 304.252 228.923 304.751 229.316 305.043",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M225.675 374.856C227.632 376.537 230.374 376.958 232.745 375.943",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M223.487 406.745L230.39 406.38",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M207.148 383.777L204.625 381.928",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M263.438 375.052C263.584 375.681 263.464 376.343 263.106 376.881",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M185.713 501.091C186.972 502.151 188.805 502.168 190.083 501.132",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M231.541 516.596L238.756 514.252",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M124.229 603.511C122.359 604.306 120.623 605.387 119.084 606.715L124.86 607.646",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M293.068 611.854L292.718 616.156C295.893 614.307 299.42 613.141 303.071 612.733",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M189.489 463.5L142.586 506.71L138.722 502.511L185.629 459.287C186.403 458.574 187.508 458.346 188.502 458.694C189.496 459.042 190.217 459.91 190.377 460.951C190.525 461.895 190.192 462.852 189.489 463.5Z",
    fill: "#4F4F5B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 458,
    width: 53,
    height: 49
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.489 463.5L142.586 506.71L138.722 502.511L185.629 459.287C186.403 458.574 187.508 458.346 188.502 458.694C189.496 459.042 190.217 459.91 190.377 460.951C190.525 461.895 190.192 462.852 189.489 463.5Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.887 476.742C150.802 489.311 156.525 496.37 156.525 496.37C156.525 496.37 153.663 505.296 153.255 505.433C152.846 505.569 142.106 503.836 142.106 503.836L146.715 479.201",
    fill: "#FFCD07"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.489 463.5L142.586 506.71L138.722 502.511L185.629 459.287C186.403 458.574 187.508 458.346 188.502 458.694C189.496 459.042 190.217 459.91 190.377 460.951V460.951C190.525 461.895 190.192 462.852 189.489 463.5Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.028,
    cy: 617.256,
    rx: 8.26511,
    ry: 8.28777,
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6106 606.439L27.6761 606.856C27.6761 606.856 30.7936 610.962 28.1331 614.365C26.8783 614.315 25.7349 615.081 25.3021 616.259C24.8693 617.438 25.2458 618.762 26.2343 619.536C27.2228 620.31 28.5978 620.359 29.6386 619.657C30.6795 618.954 31.1488 617.661 30.8005 616.454L39.6106 606.439Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M28.211 608.517C29.8372 610.286 32.1012 611.336 34.5027 611.433C36.9041 611.529 39.2453 610.666 41.0087 609.033L147.671 510.348C151.347 506.942 151.577 501.204 148.185 497.515L136.681 485.013L16.7073 596.015L28.211 608.517Z",
    fill: "#4F4F5B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_683_328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 485,
    width: 135,
    height: 127
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.211 608.517C29.8372 610.286 32.1012 611.336 34.5027 611.433C36.9041 611.529 39.2453 610.666 41.0087 609.033L147.671 510.348C151.347 506.942 151.577 501.204 148.185 497.515L136.681 485.013L16.7073 596.015L28.211 608.517Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_683_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.40045 581.553C61.2775 628.303 138.935 502.059 148.185 497.515C157.436 492.971 145.571 539.534 145.571 539.534L80.1708 584.02L48.9242 637.958L0.999929 632.633L-2.66895 576.319",
    fill: "#FFCD07"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.211 608.517C29.8372 610.286 32.1012 611.336 34.5027 611.433C36.9041 611.529 39.2453 610.666 41.0087 609.033L147.671 510.348C151.347 506.942 151.577 501.204 148.185 497.515L136.681 485.013L16.7073 596.015L28.211 608.517Z",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M123.375 470.551C121.748 468.782 119.484 467.733 117.083 467.636C114.682 467.539 112.34 468.402 110.577 470.035L3.9151 568.72C0.238892 572.126 0.00883269 577.864 3.40053 581.553L14.9043 594.055L134.879 483.053L123.375 470.551Z",
    fill: "#4F4F5B",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9041 594.055L16.7073 596.014L136.682 485.013L134.878 483.053L14.9041 594.055Z",
    fill: "#FFCD07",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6679 493.819C92.9793 495.746 91.861 497.49 90.3979 498.92",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M54.416 571.046L48.24 577.969",
    stroke: "#3D3D3C",
    strokeWidth: 1.48613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_683_328",
    x1: 1113.69,
    y1: 57.2599,
    x2: 1129.8,
    y2: 57.2599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9609,
    stopColor: "#F7748C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome3);
export default __webpack_public_path__ + "static/media/home3.063a91c3be497eb2c18d63c2d58c281f.svg";
export { ForwardRef as ReactComponent };